import { render } from "./TextusForm.vue?vue&type=template&id=1e6d3a0c&scoped=true"
import script from "./TextusForm.js?vue&type=script&lang=js&external"
export * from "./TextusForm.js?vue&type=script&lang=js&external"

import "./TextusForm.vue?vue&type=style&index=0&id=1e6d3a0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6d3a0c"],['__file',"src/Components/ChatWidget/TextusForm/TextusForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e6d3a0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e6d3a0c', __exports__)) {
    api.reload('1e6d3a0c', __exports__)
  }
  
  module.hot.accept("./TextusForm.vue?vue&type=template&id=1e6d3a0c&scoped=true", () => {
    api.rerender('1e6d3a0c', render)
  })

}


export default __exports__